export interface BookingConfirmation {
  followerUrl: string
  numberOfTravellers: number
}

export const initialBookingConfirmation: BookingConfirmation = {
  followerUrl: '',
  numberOfTravellers: 0,
}
